import { MeetingTypeDictionaryEntry } from "./InMeetingAppService";
import { MeetingTypeDictionaryEntryDto } from "./api/MeetingTypeDictionaryEntryDto";

export class MeetingTypeDictionaryEntryFromResponse {
    constructor(private dictionaryEntriesFromResponse: MeetingTypeDictionaryEntryDto[]) {}

    dictionaryEntries(): MeetingTypeDictionaryEntry[] {
        return this.dictionaryEntriesFromResponse.map((x) => ({
            key: x.key,
            value: x.value,
        }));
    }
}
